import { FormItemName } from '@src/framework/workbench/drawer/constants';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { getAllChildModels } from '@src/slide/domain/ui-model/element-modeles/property/utils/merge-property';
import { RightDrawerMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import DocsConfig from '@tencent/docs-config';
import { IItems } from '../form.interface';

/**
 * 是否为原始图片
 * @param model
 * @returns
 */
export const isImage = (model: IElementBaseModel): boolean => model.type === UIModelType.IMAGE
    && (model as IPictureModel).isImage();

/**
 * 图片专项。图片设置专项需要隐藏的设置项。
 * @param model 所选元素
 * @returns
 */
export const getImageHideItems = (model: IElementBaseModel | IMultiplyModel): IItems => {
    const selectedModels = getAllChildModels(model);
    const hasImage = selectedModels?.some((model: IElementBaseModel) => isImage(model));
    return {
        [FormItemName.PICTURE_FIX_RESET]: () => (
            !!DocsConfig.getInstance().getConfig(RightDrawerMenuConfig.hidePictureFix)),
        [FormItemName.PICTURE_COLOR_RESET]: () => (
            !!DocsConfig.getInstance().getConfig(RightDrawerMenuConfig.hidePictureEffect)),
        [FormItemName.RELATIVE_IMAGE_ORIGINAL_SIZE]: () => !hasImage,
        [FormItemName.BEST_PLAY_SCALE]: () => !hasImage,
        [FormItemName.ORIGINAL_SIZE]: () => !hasImage,
        [FormItemName.ORIGINAL_SIZE_CONTENT]: () => !hasImage,
        [FormItemName.RESET_ORIGINAL_SIZE]: () => !hasImage,
        [FormItemName.RESOLUTION]: () => !hasImage,
        [FormItemName.RESOLUTION_TEXT]: () => !hasImage,
    };
};
